import { Loader2, Smartphone } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// The 9:16 cut keeps the center 31.6% of a 16:9 frame (scale-to-cover then center crop),
// so each dimmed side band is (100 - 31.64) / 2 ≈ 34.2% wide.
export default function VerticalPreviewDialog({ open, onOpenChange, imageUrl, busy, pct, ready, onBuild }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121212] border-white/10 text-white sm:max-w-lg" data-testid="vertical-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <Smartphone className="h-4 w-4 text-blue-400" /> 9:16 vertical cut
          </DialogTitle>
          <DialogDescription className="text-zinc-500 text-xs">
            The vertical cut keeps the center of every scene — the dimmed sides are cropped away. Perfect for Shorts, TikTok and Reels.
          </DialogDescription>
        </DialogHeader>
        <div className="relative aspect-video w-full overflow-hidden rounded-md border border-white/10 bg-black" data-testid="vertical-framing-preview">
          {imageUrl ? (
            <img src={imageUrl} alt="Scene framing" className="absolute inset-0 h-full w-full object-cover" />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-[#1a2036] via-[#0d1020] to-[#05060c]" />
          )}
          <div className="absolute inset-y-0 left-0 w-[34.2%] bg-black/75" />
          <div className="absolute inset-y-0 right-0 w-[34.2%] bg-black/75" />
          <div className="absolute inset-y-0 left-[34.2%] right-[34.2%] border-x-2 border-blue-400/80">
            <span className="absolute bottom-1.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-black/60 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-blue-300">
              Kept in 9:16
            </span>
          </div>
        </div>
        <button
          onClick={onBuild}
          disabled={busy}
          data-testid="vertical-build-btn"
          className="w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 py-2.5 rounded-md text-sm font-semibold transition-colors disabled:opacity-60"
        >
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Smartphone className="h-4 w-4" />}
          {busy ? (pct != null ? `Building 9:16… ${pct}%` : "Building 9:16…") : ready ? "Download 9:16 cut" : "Build & download"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
